<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <div class="row">
      <div class="col-lg-6 col-12">
        <el-form-item
          :label="L10n('principle-service')"
          prop="principleService"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.principleService"
            @input="form.principleService = valueTrimLeft($event)"
            @change="updateModelItem('principleService', { required: true })"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('c-type')"
          prop="cType"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.cType"
            @input="form.cType = valueTrimLeft($event)"
            @change="updateModelItem('cType', { required: false })"/>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('cert')"
          prop="certID"
          class="material-style">
          <select-response
            :model.sync="form.certID"
            @update:model="updateModelItem('certID', { required: false })"
            :data="dataSourceCert.records"
            :isLoading="dataSourceCert.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('lead-time-score')"
          prop="leadTimeScoreID"
          class="material-style">
          <select-response
            :model.sync="form.leadTimeScoreID"
            @update:model="updateModelItem('leadTimeScoreID', { required: false })"
            :fields="{id: 'id', title: 'scoreText'}"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('quality-score')"
          prop="qualityScoreID"
          class="material-style">
          <select-response
            :model.sync="form.qualityScoreID"
            @update:model="updateModelItem('qualityScoreID', { required: false })"
            :fields="{id: 'id', title: 'scoreText'}"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('price-score')"
          prop="priceScoreID"
          class="material-style">
          <select-response
            :model.sync="form.priceScoreID"
            @update:model="updateModelItem('priceScoreID', { required: false })"
            :fields="{id: 'id', title: 'scoreText'}"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('service-score')"
          prop="serviceScoreID"
          class="material-style">
          <select-response
            :model.sync="form.serviceScoreID"
            @update:model="updateModelItem('serviceScoreID', { required: false })"
            :fields="{id: 'id', title: 'scoreText'}"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormContacts',
  mixins: [Form],
  computed: {
    dataSourceCert () {
      return this.API('Certs/GetAllDynamic?select=id,title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    }
  }
}
</script>
